
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/ListArt',
    name: 'ListArt',
    component: () => import('../views/ListArt.vue')
  },
  {
    path: '/ListArtInfo',
    name: 'ListArtInfo',
    component: () => import('../views/ListArtInfo.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import( '../views/About.vue')
  },
  {
    path: '/remark',
    name: 'remark',
    component: () => import( '../views/Remark.vue')
  },
  {
    path: '/Recruit',
    name: 'Recruit',
    component: () => import( '../views/Recruit.vue')
  },
  {
    path: '/Product',
    name: 'Product',
    component: () => import( '../views/Product.vue')
  },
  {
    path: '/Trainingsite',
    name: 'Trainingsite',
    component: () => import( '../views/Trainingsite.vue')
  },
  {
    path: '/BothView',
    name: 'BothView',
    component: () => import( '../views/BothView.vue')
  },
  {
    path: '/SearchRet',
    name: 'SearchRet',
    component: () => import( '../views/SearchRet.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  mode:'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, saveTop) { 
    if (saveTop) { 
      return saveTop; 
    } else { 
      return { x: 0, y: 0 } 
      } 
    },
})

export default router
